import { useState, useEffect, useCallback } from 'react';
import { pick } from 'lodash/fp';

export default (isOpen, designId, leafItems, updatePricing, fields, pricedOptions) => {
  const [options, setOptions] = useState(fields);

  const setOption = useCallback((option, value) => {
    setOptions({
      ...options,
      [option]: value,
    });
  }, [options]);

  useEffect(
    () => {
      if (isOpen) {
        updatePricing(designId, leafItems, options, { mode: 'transient' });
      }
    },
    [designId, JSON.stringify(leafItems), JSON.stringify(pick(pricedOptions)(options)), isOpen],
  );

  return [
    options,
    setOption,
    setOptions,
  ];
};

